// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a869534f","239":"6dc6a0f3","667":"971a31f3"}[chunkId] + ".chunk.js";
};